import React, { useEffect, useState, useContext, useMemo } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Drawer,
  IconButton,
  Grid2, FormControl, Select, MenuItem, InputLabel
} from "@mui/material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import TimelineIcon from "@mui/icons-material/Timeline";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon, SearchIcon } from "lucide-react";
import ArrowDownwardOutlinedIcon from '@mui/icons-material/ArrowDownwardOutlined';
import { ReactComponent as DownloadIcon } from "../../../images/TraceabilityDownloadIcon.svg";
import { ReactComponent as WhitedownloadIcon } from "../../../images/WhiteDownloadIcon.svg";
import { handleProgressBar } from "../../custom-components/ProgressBar/ProgressBarWithAPI.js";
import { APITraceabilityMatrix } from "../../../services/webServices";
import { LoadingModalContext } from "../../main-pages/ServicePage";
import CommonDownload from "../../custom-components/CommonDownload.js";
import { flattenArray, flattenObject } from "../../../utils/dataFlatteners";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import Grid from '@mui/material/Grid2';





const APITestCasesDisplayPage = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const { setLoadingState } = useContext(LoadingModalContext);
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState(location.state?.generateTestCasesData || []);
  const [traceabilityMatrixData, setTraceabilityMatrixData] = useState([]);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [downloadOpen, setDownloadOpen] = useState(false);
  const [downloadRTMOpen, setDownloadRTMOpen] = useState(false);
  const [selectedTestCase, setSelectedTestCase] = useState(null);
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  // const [search, setSearch] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [editDrawerOpen, setEditDrawerOpen] = useState(false);
  const [testCaseToEdit, setTestCaseToEdit] = useState({});
const [editingIndex, setEditingIndex] = useState(-1)


  let traceabilityMatrix = null;




  useEffect(() => {
    console.log("Location state:", location.state);
    setRows(location.state.generateTestCasesData || []);
    console.log("Rows data:", location.state.generateTestCasesData);
    setCategories(location.state.testCasesToGenerate);
  }, [location.state]);






  const getGridSize = (arrayLength) => {
    const totalCards = arrayLength + 1; // +1 for Total Test Cases card
    if (totalCards <= 12) {
      return 12 / totalCards; // Equal distribution for up to 12 items
    }
    return 1; // Minimum size for more than 12 items
  };

  // Handle card click to filter by category
  const handleCategoryClick = (category) => {
    if (selectedCategory === category) {
      // If same category is clicked, clear the filter
      setSelectedCategory('');
    } else {
      // Set new category filter
      setSelectedCategory(category);
      setSearch(''); // Clear search when filtering by category
    }
  };





  const generateTraceabilityMatrix = async () => {
    console.log("Generating Traceability Matrix...");

    let progressHandler;
    progressHandler = handleProgressBar({ setLoadingState, totalDurationMs: 216000 });
    progressHandler.start("Generating Traceability Matrix");

    const filteredTestCases = rows?.map(testcase => ({
      "Test Case ID": testcase["Test Case ID"],
      "API Endpoint": testcase["API Endpoint"],
      "Method": testcase["Method"],
      "Test Description": testcase["Test Description"],
      "Category": testcase["Category"]

    }))

    try {
      const response = await APITraceabilityMatrix(filteredTestCases);



      if (response.data !== null) {
        traceabilityMatrix = response.data;
        setTraceabilityMatrixData(response.data)
        console.log("Traceability Matrix Data:", response.data);
        setDownloadRTMOpen(true);
      }
      await progressHandler.finishAndClose();

    } catch (error) {
      console.error(
        error?.response?.data?.error || error.message,
        "Error processing item"

      );
      setPopupMessage("Error generating traceability matrix. Please try again.");
      setPopupOpen(true);
    }
    finally {
      if (progressHandler) {
        progressHandler.stop();
      }
      setLoadingState({ open: false, message: "", progress: null });
    }
  }

  console.log("Rows data:", rows)
  // const filteredRows = rows.filter((row) =>

  //   Object.values(row).some((val) =>
  //     val.toString().toLowerCase().includes(search.toLowerCase())
  //   )
  // );

  const filteredRows = useMemo(() => {
    let filtered = rows;

    if (selectedCategory) {
      filtered = filtered.filter((row) => row["Sub-Category"] === selectedCategory);
    }

    // Then filter by search text
    if (search) {
      filtered = filtered.filter((row) =>
        Object.values(row).some((val) =>
          val?.toString().toLowerCase().includes(search.toLowerCase())
        )
      );
    }

    return filtered;
  }, [rows, search, selectedCategory]);

  const renderInputData = (inputData) => {
    if (!inputData || Object.keys(inputData).length === 0) {
      return "No input data";
    }
    if (typeof inputData === 'object') {
      return JSON.stringify(inputData, null, 2);
    }
    return inputData;
  };

  const tableDataConverter = (testCases) => {
  if (!testCases?.length) {
    return { headers: [], values: [] };
  }

  const headers = Object.keys(testCases[0]);
  const values = testCases.map((eachTestCase) => Object.values(eachTestCase));
  
  return { headers, values };
};

  const handleOpenDetails = (testCase) => {
    setSelectedTestCase(testCase);
    setIsDetailsOpen(true);
  };

  const handleCloseDetails = () => {
    setSelectedTestCase(null);
    setIsDetailsOpen(false);
  };






  const handleTracabilityMatrixData = (traceabilityMatrixData) => {
    const headers = [
      "Requirement ID",
      "Test Conditions Summary",
      "Test Case ID(s)",
    ];

    const values = [];
    Object.entries(traceabilityMatrixData).map(([key, value]) => {
      if (key === "Summary of Findings") return;
      if (Array.isArray(value)) {
        value.map((eachTrace) => {
          const requirementId = eachTrace["Requirement ID"] || "";
          const testConditionId = eachTrace["Test Conditions Summary"] || "";
          const testCaseIds = (eachTrace["Test Case ID(s)"] || [])
            .map((testCase) => testCase["Test Case ID"] || "")
            .join(", ");
          return values.push([
            requirementId,
            testConditionId,
            testCaseIds,
          ]);
        });
      } else {
        console.error(`Expected an array but got: ${typeof value}`, value);
      }
    });

    return { headers, values };
  };

  const handleSummaryOfFindings = (traceabilityMatrixData) => {
    const summaryOfFindings =
      traceabilityMatrixData["Summary of Findings"] || {};
    const uncoveredRequirements =
      summaryOfFindings["Uncovered Requirements"] || [];
    const redundantTestCases = summaryOfFindings["Redundant Test Cases"] || [];
    const summaryData = [];
    if (uncoveredRequirements.length > 0) {
      summaryData.push(
        `\nUNCOVERED REQUIREMENTS:\n\n${uncoveredRequirements
          .map((eachRequirement) => {
            return `Requirement ID: ${eachRequirement["Requirement ID"]}\nDescription: ${eachRequirement["Description"]}\n`;
          })
          .join("\n")}`
      );
    }
    if (redundantTestCases.length > 0) {
      summaryData.push(
        `\nREDUNDANT TEST CASES:\n${redundantTestCases
          .map((eachTestCase) => {
            return `Test Case ID: ${eachTestCase["Test Case ID"]}\nDescription: ${eachTestCase["Description"]}`;
          })
          .join("\n")}`
      );
    }

    return summaryData.join("\n");
  };

  console.log("All Test Cases Data:", rows);

  const formattedTestCases = [];
  rows.map((testCase) => {
    const flattenTestCase = {};
    Object.entries(testCase).map(([key, value]) => {
      if (Array.isArray(value)) {
        return (flattenTestCase[key] = flattenArray(value));
      } else if (typeof value === "object" && !!value) {
        return (flattenTestCase[key] = flattenObject(value));
      } else {
        return (flattenTestCase[key] = value);
      }
    });
    return formattedTestCases.push(flattenTestCase);
  })
  console.log("Formatted Test Cases:", formattedTestCases);

  const handleEditDrawerclose = () => {
    setEditDrawerOpen(false);
    setTestCaseToEdit({});
     setEditingIndex(-1);
    

  }
  const handleEditTestCase = (testCase, index) => {
    setTestCaseToEdit({ ...testCase }); 
    setEditingIndex(index);
    setEditDrawerOpen(true);
  };

  // const handleSaveTestCase = () => {
  //   try {
  //       let newRows;
 
  //     if (editingIndex !== -1) {
  //       setRows(prevRows => {
  //         const updatedRows = [...prevRows];
  //         updatedRows[editingIndex] = { ...testCaseToEdit };
  //         newRows=updatedRows;
  //         return updatedRows;

  //       });
  //     } else {
        
  //       setRows(prevRows => {
  //      const updatedRows =   prevRows.map(row =>
  //           row["Test Case ID"] === testCaseToEdit["Test Case ID"]
  //             ? { ...testCaseToEdit } 
  //             : row 
  //         );
  //         newRows= updatedRows;
  //         return updatedRows
  //     });
  //     }
  //        navigate(location.pathname, {
  //     replace: true,
  //     state: {
  //       ...location.state,
  //       generateTestCasesData: newRows || []
  //     }
  //   });

     
  //   handleEditDrawerclose();

  //   } catch (error) {
  //     console.error("Error updating test case:", error);
  //     alert("Failed to update test case. Please try again.");
  //   }
  // };
const handleSaveTestCase = () => {
  try {
    let updatedRows;
    
 
    if (editingIndex !== -1) {
      updatedRows = [...rows];
      updatedRows[editingIndex] = { ...testCaseToEdit };
    } else {
      updatedRows = rows.map(row =>
        row["Test Case ID"] === testCaseToEdit["Test Case ID"]
          ? { ...testCaseToEdit } 
          : row 
      );
    }

   
    if (!updatedRows || updatedRows.length === 0) {
      console.warn("No rows to update");
      handleEditDrawerclose();
      return;
    }


    setRows(updatedRows);


    navigate(location.pathname, {
      replace: true,
      state: {
        ...location.state,
        generateTestCasesData: updatedRows
      }
    });

    handleEditDrawerclose();

  } catch (error) {
    console.error("Error updating test case:", error);
    alert("Failed to update test case. Please try again.");
  }
};
  return (
    <Box sx={{ p: 2,
      bgcolor: "#F6F3F2",
                display: "flex",
                flexDirection: "column",
                height: "100%",
                maxHeight: "100%",
                minHeight: 0,
     }}>
  <Box
                sx={{
                    width: "100%",
                    // height: { xs: "60vh", sm: "65vh", md: "73vh" }, // 

                    overflowY: "scroll", // scrolling works
                    scrollbarWidth: "none", // Firefox
                    "&::-webkit-scrollbar": {
                        display: "none", // Chrome, Safari, Edge
                    },  // adds scroll if content is taller
                    // mx: "auto",
                    mb: 2
                }}
            >
      <Grid container spacing={1} sx={{ mb: 4 }}>
        <Grid size={getGridSize(categories.length)}>
          <Card
            sx={{
              minHeight: 80,
              display: 'flex',
              alignItems: 'left',
              justifyContent: 'left',
              boxShadow: "none",
             
              border: '#E2E2E2',
                backgroundColor: selectedCategory === "" ? '#E1F5FF' : '#fff', // Active if no category selected
              '&:hover': {
                backgroundColor: '#E1F5FF',
                  // boxShadow: 4,

              },

              cursor: 'pointer'

            }}
            onClick={() => setSelectedCategory("")}
          >
            <CardContent sx={{ textAlign: 'left' }}>
              <Typography
                variant="h6"
                component="div"
                sx={{
                  fontWeight: 600,
                  color: '#0094FB',
                  fontSize: { xs: '0.9rem', sm: '1.1rem', md: '1.25rem' }
                }}
              >
                {rows.length}
              </Typography>
              <Typography
                variant="body2"
                color="black"
                sx={{ mt: 1, fontSize: 10}}
              >
                Total test cases
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {categories.map((location, index) => (
          <Grid
            key={index}
            size={getGridSize(categories.length)}
          >


            <Card
              sx={{
                minHeight: 40,
                display: 'flex',
                alignItems: 'left',
                justifyContent: 'left',
                boxShadow: "none",

               backgroundColor: selectedCategory === location ? '#E1F5FF' : '#fff',
               border: ' #E2E2E2',
                '&:hover': {
                  backgroundColor: '#E1F5FF',
                 
                 
                },
              
                cursor: 'pointer'

              }}
              onClick={() => handleCategoryClick(location)}
            >
              <CardContent sx={{ textAlign: 'left' }}>
                <Typography
                  variant="h6"
                  component="div"
                  sx={{
                    fontWeight: 600,
                    color: '#0094FB',
                    fontSize: { xs: '0.9rem', sm: '1.1rem', md: '1.25rem' }
                  }}
                >
                  {rows.filter(row => row["Sub-Category"] === location).length}
                </Typography>
                <Typography
                  variant="body2"
                  color="black"
                  sx={{ mt: 1 , fontSize: 10}}
                >
                  {location}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Card
        variant="outlined"
        sx={{ p: 2, borderRadius: 2, backgroundColor: "#fff", border: "none",pr:0,pl:0 }}
      >
        <CardContent>
          <Box>
            {/* Header */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 1,
              }}
            >
              <Typography variant="subtitle1" fontWeight="bold" sx={{ fontSize: 17 }}>
                Test Cases
              </Typography>
              <TextField
                InputProps={{
                  startAdornment: (
                    <SearchIcon style={{ color: "#a9a9a9", marginRight: 8 }} />
                  ),
                }}
                placeholder="Search by test cases, test case ID, etc,.
 "
                variant="outlined"

                size="small"
                sx={{ mb: 2, width: 500 }}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </Box>

            {/* Table */}

            <Box sx={{ maxHeight: 600, width: "100%", overflowX: "auto", overflowY: "auto", textAlign: "center", color: "text.secondary", pr:0, pl:0}}>


              <TableContainer sx={{ maxHeight: 600 }}>
                <Table stickyHeader sx={{ border: '1px solid #e0e0e0', borderLeft: 'none', borderRight: 'none' }}>
                  <TableHead>
                    <TableRow>

                      <TableCell
                        sx={{
                          position: "sticky",
                          left: 0,
                          zIndex: 3, // higher than body cells so it stays above when scrolling
                          backgroundColor: "#f8f8f8",
                          borderRight: "1px solid  #E2E2E2",
                       
                        }}
                      ><b>Test Case ID</b>
                        <ArrowDownwardOutlinedIcon sx={{
                          fontSize: "medium", ml: 0.3, position: "relative",
                          top: "3px"
                        }} />

                      </TableCell>
                      <TableCell 
                      sx={{ backgroundColor: "#f8f8f8"}}
                      ><b>Test Case Title</b>
                        <ArrowDownwardOutlinedIcon sx={{
                          fontSize: "medium", ml: 0.3, position: "relative",
                           
                          top: "3px"
                        }} />
                      </TableCell>
                      <TableCell
                       sx={{ backgroundColor: "#f8f8f8"}}
                      ><b>API Endpoint</b>
                        <ArrowDownwardOutlinedIcon sx={{
                          fontSize: "medium", ml: 0.3, position: "relative",
                          top: "3px"
                        }} />
                      </TableCell>
                      <TableCell
                       sx={{ backgroundColor: "#f8f8f8"}}><b>Method</b>
                        <ArrowDownwardOutlinedIcon sx={{
                          fontSize: "medium", ml: 0.3, position: "relative",
                          top: "3px",
                             
                        }} />
                      </TableCell>
                      <TableCell  sx={{ backgroundColor: "#f8f8f8"}}><b>Test Description</b>
                        <ArrowDownwardOutlinedIcon sx={{
                          fontSize: "medium", ml: 0.3, position: "relative",
                          top: "3px",
                            
                        }} />
                      </TableCell>
                      <TableCell  sx={{ backgroundColor: "#f8f8f8"}}><b>Test Steps</b>
                        <ArrowDownwardOutlinedIcon sx={{
                          fontSize: "medium", ml: 0.3, position: "relative",
                          top: "3px",
                            
                        }} />
                      </TableCell>
                      <TableCell  sx={{ backgroundColor: "#f8f8f8"}}><b>Input Data</b>
                        <ArrowDownwardOutlinedIcon sx={{
                          fontSize: "medium", ml: 0.3, position: "relative",
                          top: "3px",
                             backgroundColor: "#f8f8f8",
                        }} />
                      </TableCell>
                      <TableCell  sx={{ backgroundColor: "#f8f8f8"}}><b>Expected Result</b>
                        <ArrowDownwardOutlinedIcon sx={{
                          fontSize: "medium", ml: 0.3, position: "relative",
                          top: "3px",
                             backgroundColor: "#f8f8f8",
                        }} />
                      </TableCell>
                      <TableCell  sx={{ backgroundColor: "#f8f8f8"}}><b>Category</b>
                        <ArrowDownwardOutlinedIcon sx={{
                          fontSize: "medium", ml: 0.3, position: "relative",
                          top: "3px",
                             backgroundColor: "#f8f8f8",
                        }} />
                      </TableCell>
                      <TableCell  sx={{ backgroundColor: "#f8f8f8"}}><b>Sub Category</b>
                        <ArrowDownwardOutlinedIcon sx={{
                          fontSize: "medium", ml: 0.3, position: "relative",
                          top: "3px",
                             backgroundColor: "#f8f8f8",
                        }} />
                      </TableCell>
                      <TableCell sx={{
                        position: "sticky",
                        right: 0,
                        zIndex: 3,
                           backgroundColor: "#f8f8f8",
                        minWidth: 80,
                         borderLeft : '1px solid #E2E2E2'
                      }}><b>Actions</b>
                        <ArrowDownwardOutlinedIcon sx={{
                          fontSize: "medium", ml: 0.3, position: "relative",
                          top: "3px"
                        }} />
                      </TableCell>

                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredRows.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell
                          sx={{
                            position: "sticky",
                            left: 0,
                            zIndex: 1,
                            backgroundColor: "#fff",
                            minWidth: 200,
                            cursor: "pointer",
                            color: "#1976d2",
                             borderRight: "1px solid  #E2E2E2"

                          }}

                          onClick={() => handleOpenDetails(row)}
                        >{row["Test Case ID"]}</TableCell>
                        <TableCell sx={{ color: "text.secondary", minWidth: 150 , }}>{row["Test Case Title"]}</TableCell>
                        <TableCell sx={{ color: "text.secondary", minWidth: 200 }}>{row["API Endpoint"]}</TableCell>
                        <TableCell sx={{ color: "text.secondary", minWidth: 200 }}>{row["Method"]}</TableCell>
                        <TableCell sx={{ color: "text.secondary", minWidth: 200 }}>{row["Test Description"]}</TableCell>
                        <TableCell sx={{ color: "text.secondary", minWidth: 200 }}>{row["Test Steps"]}</TableCell>
                        <TableCell sx={{ color: "text.secondary", minWidth: 200 }}>{renderInputData(row["Input Data"])}</TableCell>
                        <TableCell sx={{ color: "text.secondary", minWidth: 200 }}>{row["Expected Result"]}</TableCell>
                        <TableCell sx={{ color: "text.secondary", minWidth: 200 }}>{row["Category"]}</TableCell>
                        <TableCell sx={{ color: "text.secondary", minWidth: 200 }}>{row["Sub-Category"]}</TableCell>
                        <TableCell
                          sx={{
                            position: "sticky",
                            right: 0,
                            zIndex: 1,
                            backgroundColor: "#fff",
                            minWidth: 100,
                          //  display: "flex",
                           textAlign: "center",
                            borderLeft : '1px solid #E2E2E2'
                            
                          }}
                        >
                          <IconButton
                            color="primary"
                            onClick={() =>  handleEditTestCase(row, rows.indexOf(row))} 


                            size="small"
                          >
                            <ModeEditOutlinedIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                    {filteredRows.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={8} align="center">
                          No results found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Box>

    
         
        </CardContent>
      </Card>
      </Box>
       <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2,  }}>
            <Button variant="outlined" startIcon={<DownloadIcon />} sx={{
              borderRadius: "6px", color: "#0094FB", borderColor: " #0094FB",
              borderWidth: "2px",   // makes border bold
              fontWeight: "bold", textTransform: "none",
              padding: "4px 16px"
            }}
              onClick={generateTraceabilityMatrix}>
              Traceability Matrix
            </Button>
            <Button variant="contained" startIcon={<WhitedownloadIcon />} sx={{
              borderRadius: "8px",
              backgroundColor: "#0094FB",
              textTransform: "none",
              fontWeight: "bold",
              padding: "4px 16px"

            }}
              onClick={() => setDownloadOpen(true)}
            >
              Download Test Cases
            </Button>
             <Button variant="contained" sx={{
              borderRadius: "8px",
              backgroundColor: "#0094FB",
              textTransform: "none",
              fontWeight: "bold",
              padding: "4px 16px"

            }}
             onClick={() =>
             {
                navigate("/dashboard/api-testing/choose-testcase", {
        state: { testCaseData: rows }
             })
             }
            }
            >
              Start Automation
            </Button>
          </Box>
      <Drawer
        anchor="right"

        open={isDetailsOpen}
        onClose={handleCloseDetails}
        PaperProps={{ sx: { width: "40%", p: 3 } }}
      >
        <Box>
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <IconButton onClick={handleCloseDetails} ><ArrowBackIcon /></IconButton>
              <Typography variant="h6">Test Case Details</Typography>
            </Box>
            <IconButton onClick={handleCloseDetails}><CloseIcon /></IconButton>
          </Box>

          {selectedTestCase && (
            <Box>
              <Box mb={2}>
                <Typography variant="subtitle1">Test Case Title</Typography>
                <Typography color="text.secondary" fontSize={15}>{selectedTestCase["Test Case Title"]}</Typography>
              </Box>

              <Box mb={2}>
                <Typography variant="subtitle1">Test Case ID</Typography>
                <Typography color="text.secondary" fontSize={15}>{selectedTestCase["Test Case ID"]}</Typography>
              </Box>

              <Box mb={2}>
                <Typography variant="subtitle1">API Endpoint</Typography>
                <Typography color="text.secondary" fontSize={15}>{selectedTestCase["API Endpoint"]}</Typography>
              </Box>

              <Box mb={2}>
                <Typography variant="subtitle1">Method</Typography>
                <Typography color="text.secondary" fontSize={15}>{selectedTestCase["Method"]}</Typography>
              </Box>

              <Box mb={2}>
                <Typography variant="subtitle1">Test Description</Typography>
                <Typography color="text.secondary" fontSize={15}>{selectedTestCase["Test Description"]}</Typography>
              </Box>


              <Box mb={2}>
                <Typography variant="subtitle1">Test Steps</Typography>
                {selectedTestCase["Test Steps"] &&
                  selectedTestCase["Test Steps"]
                    .split(/\d+\.\s+/)
                    .filter(step => step.trim() !== "") // remove empty items
                    .map((step, index) => (
                      <Typography key={index} color="text.secondary" fontSize={15}>
                        {index + 1}. {step.trim()}
                      </Typography>
                    ))
                }
              </Box>

              <Box mb={2}>
                <Typography variant="subtitle1">Input Data</Typography>
                <Typography color="text.secondary" fontSize={15}>{renderInputData(selectedTestCase["Input Data"])}</Typography>
              </Box>




              <Box mb={2}>
                <Typography variant="subtitle1">Category</Typography>
                <Typography color="text.secondary" fontSize={15}>{selectedTestCase["Category"]}</Typography>
              </Box>

              <Box mb={6}>
                <Typography variant="subtitle1">Sub-Category</Typography>
                <Typography color="text.secondary" fontSize={15}>{selectedTestCase["Sub-Category"]}</Typography>
              </Box>
            </Box>
          )}
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 2, mb: 4, width: "100%" }}>
            <Button variant="contained" sx={{
              borderRadius: "8px",
              backgroundColor: "#0094FB",
              textTransform: "none",
              fontWeight: "bold",
              padding: "4px 16px"

            }}
              onClick={handleCloseDetails}
            >
              Ok
            </Button>
          </Box>
        </Box>
      </Drawer>

      <Drawer
        anchor="right"

        open={editDrawerOpen}
        onClose={handleEditDrawerclose}
        PaperProps={{ sx: { width: "40%", p: 3 } }}
      >
        <Box>
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <IconButton onClick={handleEditDrawerclose} ><ArrowBackIcon /></IconButton>
              <Typography variant="h6">Edit Test Case</Typography>
            </Box>
            <IconButton onClick={handleEditDrawerclose}><CloseIcon /></IconButton>
          </Box>

          <TextField
            label="Test case title"
            fullWidth
            placeholder="Enter Test case title"
            value={testCaseToEdit["Test Case Title"] || ""}
            onChange={(e) =>
              setTestCaseToEdit((prev) => ({
                ...prev,
                ["Test Case Title"]: e.target.value,
              }))
            }

            sx={{ mb: 2 }}

          >
          </TextField>

          <TextField
            label="Test case ID"
            fullWidth
            placeholder="Enter Test case ID"
            value={testCaseToEdit["Test Case ID"]}
            sx={{ mb: 2 }}
            onChange={(e) =>
              setTestCaseToEdit((prev) => ({
                ...prev,
                ["Test Case ID"]: e.target.value,
              }))
            }
          ></TextField>

          <TextField
            label="API Endpoint"
            fullWidth
            placeholder="Enter API Endpoint"
            sx={{ mb: 2 }}
            value={testCaseToEdit["API Endpoint"]}
            onChange={(e) =>
              setTestCaseToEdit((prev) => ({
                ...prev,
                ["API Endpoint"]: e.target.value,
              }))
            }
          ></TextField>

          <FormControl fullWidth>
            <InputLabel >Method</InputLabel>
            <Select
              label="Method"
              placeholder="Select Method"
              sx={{ mb: 2 }}
              value={testCaseToEdit["Method"] || ""}
              onChange={(e) =>
                setTestCaseToEdit((prev) => ({
                  ...prev,
                  ["Method"]: e.target.value,
                }))
              }

            >
              <MenuItem value="GET">GET</MenuItem>
              <MenuItem value="PUT">PUT</MenuItem>
              <MenuItem value="POST">POST</MenuItem>
              <MenuItem value="Delete">Delete</MenuItem>

            </Select>
          </FormControl>

          <TextField
            label="Input Data"
            fullWidth
            placeholder="Enter Input Data"
            sx={{ mb: 2 }}
            multiline
            minRows={4}
            value={renderInputData(testCaseToEdit["Input Data"] || "")}

            onChange={(e) =>
              setTestCaseToEdit((prev) => ({
                ...prev,
                ["Input Data"]: e.target.value,
              }))
            }
          ></TextField>

          <FormControl fullWidth>
            <InputLabel >Category</InputLabel>
            <Select
              label="Category"
              placeholder="Enter Category"
              sx={{ mb: 2 }}
              value={testCaseToEdit["Category"] || ""}
              onChange={(e) =>
                setTestCaseToEdit((prev) => ({
                  ...prev,
                  ["Category"]: e.target.value,
                }))
              }
            >
              <MenuItem value="Functional Testing">Functional Testing</MenuItem>
              <MenuItem value="Non-Functional Testing">Non-Functional Testing</MenuItem>


            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel >Sub-Category</InputLabel>
            <Select
              label="Sub-Category"
              placeholder="Enter Sub-Category"
              sx={{ mb: 2 }}
              value={testCaseToEdit["Sub-Category"] || ""}
              onChange={(e) =>
                setTestCaseToEdit((prev) => ({
                  ...prev,
                  ["Sub-Category"]: e.target.value,
                }))
              }

            >
              <MenuItem value="Positive Test case">Postive Test case</MenuItem>
              <MenuItem value="Negative Test case">Negative Test case</MenuItem>


            </Select>
          </FormControl>

          <TextField
            label="Test Steps"
            fullWidth
            placeholder="Enter Test Steps"
            multiline
            sx={{ mb: 2 }}
            minRows={4}
            value={testCaseToEdit["Test Steps"] || ""}
            onChange={(e) =>
              setTestCaseToEdit((prev) => ({
                ...prev,
                ["Test Steps"]: e.target.value,
              }))
            }
          ></TextField>

          <TextField
            label="Test Description"
            fullWidth
            placeholder="Enter Test Description"
            multiline
            sx={{ mb: 2 }}
            minRows={4}
            value={testCaseToEdit["Test Description"] || ""}
            onChange={(e) =>
              setTestCaseToEdit((prev) => ({
                ...prev,
                ["Test Description"]: e.target.value,
              }))
            }
          ></TextField>

          <TextField
            label="Expected Result"
            fullWidth
            placeholder="Enter Expected Result"
            multiline
            sx={{ mb: 2 }}
            value={testCaseToEdit["Expected Result"] || ""}
            onChange={(e) =>
              setTestCaseToEdit((prev) => ({
                ...prev,
                ["Expected Result"]: e.target.value,
              }))
            }
            minRows={4}
          ></TextField>

          <Box sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: 2,
            p: 2,
            mb: 2,

          }}>
            <Button variant="outlined"
              onClick={handleEditDrawerclose}
              sx={{
                borderRadius: "8px", color: "#0094FB", borderColor: " #0094FB",
                borderWidth: "2px",   // makes border bold
                fontWeight: "bold", textTransform: "none",
                padding: "4px 16px",
                mb: 1,

              }
              }
            >
              Cancel
            </Button>


            <Button variant="contained" sx={{
              borderRadius: "8px",
              backgroundColor: "#0094FB",
              textTransform: "none",
              fontWeight: "bold",
              padding: "5px 16px",
              mb: 1,
            }}
            onClick={handleSaveTestCase}

            >
              Save
            </Button>

          </Box>



        </Box>


      </Drawer>
      <CommonDownload
        open={downloadOpen}
        onClose={() => setDownloadOpen(false)}

        serviceResponse={[formattedTestCases]}
        serviceName="TestCases_Report"
        wordData={[
          {
            heading: "Test Cases",
            type: "table",
            data: { ...tableDataConverter(formattedTestCases) },
          },
        ]}
        documents={["xls", "csv"]}
      />
      <CommonDownload
        open={downloadRTMOpen}
        onClose={() => setDownloadRTMOpen(false)}
        serviceResponse={[
          {
            heading: "Requirement Traceability Matrix",
            type: "table",
            data: handleTracabilityMatrixData(traceabilityMatrixData),
          },
          {
            heading: "Summary of Findings",
            type: "text",
            data: handleSummaryOfFindings(traceabilityMatrixData),
          },
        ]}
        serviceName="Requirement Traceability Matrix"
        wordData={[
          {
            heading: "Requirement Traceability Matrix",
            type: "table",
            data: handleTracabilityMatrixData(traceabilityMatrixData),
          },
          {
            heading: "Summary of Findings",
            type: "text",
            data: handleSummaryOfFindings(traceabilityMatrixData),
          },
        ]}
        documents={["docx", "pdf"] || []}
      />
    </Box>
  );
};

export default APITestCasesDisplayPage;
